// Cached reference data (spec §11): the tariff snapshot + distance matrix the
// browser engine needs to price offline. Fetched once online, then read from
// IndexedDB so the calculator works with no network.

import { openOperatorDB, PROVISIONING_KEY, type ProvisioningBlob } from "./db";

export async function saveProvisioning(blob: ProvisioningBlob): Promise<void> {
  const db = await openOperatorDB();
  await db.put("provisioning", { ...blob, id: PROVISIONING_KEY });
}

export async function loadProvisioning(): Promise<ProvisioningBlob | undefined> {
  const db = await openOperatorDB();
  return db.get("provisioning", PROVISIONING_KEY);
}

/** Normalize a city pair to (low, high) and look up the cached distance string;
 *  null when the pair is unknown (→ distance_missing). */
export function makeDistanceLookup(
  distances: Array<[number, number, string]>,
): (a: number, b: number) => string | null {
  const map = new Map<string, string>();
  for (const [lo, hi, dist] of distances) {
    map.set(`${lo}:${hi}`, dist);
  }
  return (a, b) => {
    if (a === b) {
      return "0";
    }
    const lo = Math.min(a, b);
    const hi = Math.max(a, b);
    return map.get(`${lo}:${hi}`) ?? null;
  };
}
